import router from '.';
import HelperTools from "@/helpers/helper"

const {omit} = HelperTools.HelperTools


async function beforeEach(to, from, next) {
  // console.log("to:", to)
  const { name, params } = to;
  if (["AddressDetail", "AddressDetailTestNormalized"].includes(name) ) {
    return next({
      name: 'Address',
      params: {
        ...params,
      },
      query: omit(params, 'address', 'net')
    })
  }
  if (["TokenDetailNormalized", "TokenDetailTestNormalized", "TokenAnalyticsNormalized"].includes(name)) {
    return next({
      name: 'Token',
      params: {
        ...params,
      },
      query: omit(params, 'contractHash', 'net')
    })
  }
  next()
}

export default {
  install() {
    router.beforeEach(beforeEach);
  },
};



// WEBPACK FOOTER //
// ./src/router/hooks.js